//@flow
export default {
  secondsAgo: '{0} secondes plus tôt',
  minutesAgo: '{0} minutes plus tôt',
  hoursAgo: '{0} heures plus tôt',
  daysAgo: '{0} jours plus tôt',
  monthsAgo: '{0} mois plus tôt',
  yearsAgo: '{0} années plus tôt',
  secondsLeft: '{0} second{1} left',
  minutesLeft: '{0} minute{1} left',
  hoursLeft: '{0} hour{1} left',
  daysLeft: '{0} day{1} left',
  monthsLeft: '{0} month{1} left',
  yearsLeft: '{0} year{1} left',
  apiCannotBeReached: 'L\'API « {0} » est inaccessible',
  errorCode: {
    alreadyExist: '{0} already exists',
    somethingError: 'Something went wrong, please try again',
    clientPhoneWrong: 'Phone number is not correct'
  },
  noActivity: 'No Activity',
  noActivityDesc: 'There is no activity at the moment.',
  noTransactions: 'No transactions',
  noTransactionsDesc: 'You don’t have any info card transactions yet.',
  emptyPortfolio: 'Empty Portfolio',
  emptyPortfolioDesc: 'Client portfolio is currently empty.'
}
